module.exports = __webpack_public_path__ + "static/media/csohid-bontas-2.fe47153d.jpg";